import React, { useEffect, useState } from 'react'
// eslint-disable-next-line no-restricted-imports -- this is a valid import for web styled-components
import styledWeb from 'styled-components'
import { useTheme } from 'styled-components/native'
import * as SliderPrimitive from '@radix-ui/react-slider'

interface Props {
  value: number[]
  minValue: number
  maxValue: number
  onChange?: (values: number[]) => void
  onChangeFinish?: (values: number[]) => void
  step?: number
  allowOverlap?: boolean
}

const SliderRoot = styledWeb(SliderPrimitive.Root)`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 44px;
  user-select: none;
  touch-action: none;
`

const SliderTrack = styledWeb(SliderPrimitive.Track)`
  position: relative;
  border-radius: ${({ theme }) => theme.metrics.borderRadius.small / 2}px;
  height: 6px;
  background-color: ${({ theme }) => theme.colors.sliderSecondary};
  width: 100%;
`

const SliderRange = styledWeb(SliderPrimitive.Range)`
  position: absolute;
  background-color: ${({ theme }) => theme.colors.sliderPrimary};
  height: 100%;
  border-radius: ${({ theme }) => theme.metrics.borderRadius.small / 2}px;
`

const SliderThumb = styledWeb(SliderPrimitive.Thumb)`
  display: block;
  width: ${({ theme }) => theme.metrics.icon.small}px;
  height: ${({ theme }) => theme.metrics.icon.small}px;
  background-color: ${({ theme }) => theme.colors.sliderPrimary};
  border-radius: 50%;
  cursor: grab;
`

export const SliderComponent = ({
  value,
  minValue,
  maxValue,
  onChange,
  onChangeFinish,
  step = 5,
}: Props) => {
  const [internalValue, setInternalValue] = useState(value)
  const theme = useTheme()

  useEffect(() => {
    setInternalValue(value)
  }, [value])

  const handleValueChange = (newValue: number[]) => {
    setInternalValue(newValue)

    if (onChange) {
      onChange(newValue)
    }
  }

  const handlePointerUp = () => {
    if (onChangeFinish) {
      onChangeFinish(internalValue)
    }
  }

  const handleKeyUp = (event: React.KeyboardEvent) => {
    const { key } = event

    if (key === 'ArrowRight' || key === 'ArrowLeft' || key === 'ArrowUp' || key === 'ArrowDown') {
      if (onChangeFinish) {
        onChangeFinish(internalValue)
      }
    }
  }

  return (
    <SliderRoot
      theme={theme}
      value={internalValue}
      min={minValue}
      max={maxValue}
      onValueChange={handleValueChange}
      onPointerUp={handlePointerUp}
      onKeyUp={handleKeyUp}
      step={step}
      minStepsBetweenThumbs={1}
    >
      <SliderTrack theme={theme}>
        <SliderRange theme={theme} />
      </SliderTrack>
      {internalValue.map((_, index) => (
        <SliderThumb key={`thumb-${index}`} theme={theme} />
      ))}
    </SliderRoot>
  )
}
